import script from "./CollectionListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionListItem.vue?vue&type=script&setup=true&lang=js"

import "./CollectionListItem.vue?vue&type=style&index=0&id=3536137b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3536137b"]])

export default __exports__